import type { SVGProps } from "react";

const SvgComponent = (props: SVGProps<SVGSVGElement>) => (
  <svg
    aria-label="instagram"
    role="img"
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="#000"
    {...props}
  >
    <g clipPath="url(#a)">
      <path d="M17.377 0H6.623A6.63 6.63 0 0 0 0 6.623v10.754A6.63 6.63 0 0 0 6.623 24h10.754A6.63 6.63 0 0 0 24 17.377V6.623A6.63 6.63 0 0 0 17.377 0Zm4.494 17.377a4.499 4.499 0 0 1-4.494 4.494H6.623a4.499 4.499 0 0 1-4.494-4.494V6.623A4.499 4.499 0 0 1 6.623 2.13h10.754a4.499 4.499 0 0 1 4.494 4.494v10.754Z" />
      <path d="M11.997 5.817A6.191 6.191 0 0 0 5.813 12a6.191 6.191 0 0 0 6.184 6.184A6.191 6.191 0 0 0 18.18 12a6.191 6.191 0 0 0-6.184-6.184Zm0 10.238a4.06 4.06 0 0 1-4.055-4.054 4.06 4.06 0 0 1 4.055-4.055A4.06 4.06 0 0 1 16.05 12a4.06 4.06 0 0 1-4.054 4.054ZM18.448 4.01a1.569 1.569 0 0 0-1.562 1.562c0 .41.168.814.459 1.105.29.29.692.457 1.103.457.411 0 .813-.168 1.104-.457.291-.291.457-.695.457-1.105 0-.412-.166-.815-.457-1.104a1.568 1.568 0 0 0-1.104-.457Z" />
    </g>
    <defs>
      <clipPath id="a">
        <path d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgComponent;
